import React, { useEffect, useRef } from "react";
import Profile from '../asset/profil.jpeg';
import '../App.css';

const About = () => {
    return (
        <section id="about" className="py-20 bg-cream">
            <div className="container mx-auto text-center px-6">
                <h2 className="text-4xl font-bold mb-8 text-rosegold" style={{ fontFamily: 'Kavoon' }}>
                    About Me
                </h2>

                <div className="flex flex-col items-center mb-12">
                    <img src={`${Profile}`} alt="Profile Picture" className="w-32 h-32 rounded-full object-cover mb-4 shadow-lg"/>
                    <p className="text-lg text-gray-600 mb-2">KIDI Intern</p>
                    <p className="text-xl text-gray-700 font-semibold">I’m an Software engineer intern in KIDI Telkom educourse</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  <div className="bg-rosegold p-6 rounded-lg shadow-lg hover:bg-rose-400 transition-colors duration-300">
                    <div className="bg-white p-4 rounded-lg shadow-md relative">
                      <h3 className="text-2xl font-bold mb-4 text-black">React JS</h3>
                      <p className="text-gray-700 mb-4">
                      React.js adalah pustaka JavaScript yang digunakan untuk membuat antarmuka pengguna (UI) yang interaktif dan dinamis.                      </p>
                    </div>
                    </div>
                    <div className="bg-rosegold p-6 rounded-lg shadow-lg hover:bg-rose-400 transition-colors duration-300">
                     <div className="bg-white p-4 rounded-lg shadow-md">
                      <h3 className="text-2xl font-bold mb-4 text-black">UI/UX</h3>
                      <p className="text-gray-700 mb-4">
                      UI/UX adalah istilah yang merujuk pada User Interface (UI) dan User Experience (UX) yang merupakan desain yang berfokus pada interaksi pengguna dengan produk atau layanan.
                      </p>
                     </div>
                     </div>
                    
                    <div className="bg-rosegold p-6 rounded-lg shadow-lg hover:bg-rose-400 transition-colors duration-300">
                      <div className="bg-white p-4 rounded-lg shadow-md">
                       <h3 className="text-2xl font-bold mb-4 text-black">Node JS</h3>
                       <p className="text-gray-700 mb-4">
                      Node.js adalah runtime environment untuk JavaScript yang bersifat open-source dan cross-platform.
                      </p>
                     
                    </div>
                    </div>
                    </div>
                    </div>
                 
                  
        </section>

    )
}

export default About;